<pl-word-cloud *ngIf="block && block.data" [wordData]="block.data.wordData" />
